import { FaClock } from 'react-icons/fa6'
import { LuGraduationCap } from 'react-icons/lu'
import { PiBookOpenText } from 'react-icons/pi'

export const mock = {
  amoutOfClasses: 3,
  coursesComplete: 4,
  sentTask: 5,
  ranking: 6,
  percentageComparison: 45,
}

const objetoMockProgress = [
  {
    amount: mock.amoutOfClasses,
    amountTitle: 'Clases Consecutivas',
    icon: FaClock,
  },
  {
    amount: mock.coursesComplete,
    amountTitle: 'Curso Completado',
    icon: LuGraduationCap,
  },
  {
    amount: mock.sentTask,
    amountTitle: 'Tarea Enviada',
    icon: PiBookOpenText,
  },
  {
    amount: mock.ranking,
    amountTitle: 'Puntos Diga Ranking!',
    icon: '/assets/logo-sm.svg',
  },
]

export default objetoMockProgress
